import { classNames } from "shared/lib/classNames/classNames";
import { useSelector } from "react-redux";
import { SpeechBox } from "entities/SpeechBox";
import { getPlotStepData } from "widgets/PlotSteps";
import { speakerData } from "widgets/PlotSteps/model/api/speakerData";
import { useEffect } from "react";
import cls from "./LeftDialog.module.scss";

interface LeftDialogProps {
    className?: string;
}
export const LeftDialog = (props: LeftDialogProps) => {
    const { className } = props;
    const { speakerImg, speakerName, hiddenSpeaker, message } =
        useSelector(getPlotStepData).dialog;
    const buttonsCount = useSelector(getPlotStepData)?.action?.buttons?.length;

    return (
        <div className={classNames(cls.LeftDialog, {}, [className])}>
            {!hiddenSpeaker && (
                <div className={cls.imgBox}>
                    <img className={cls.img} src={speakerImg} alt="Персонаж" />
                </div>
            )}
            <SpeechBox
                className={cls.speechBox}
                name={speakerName}
                message={message}
                buttonsCount={buttonsCount}
            />
        </div>
    );
};
